import React, { useState } from 'react';
import { useData } from "../backend/firebase";
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [isRegistering, setIsRegistering] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [secretCode, setSecretCode] = useState("");
    const [error, setError] = useState("");
    
    const { login, register } = useData();
    const navigate = useNavigate();

    // Codes
    const ADMIN_CODE = "1C_1S_2C_SHOWS_4_HEARTS"; 
    const CAPTAIN_CODE = "BRAWL_CAPTAIN_2026";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            if (isRegistering) {
                let role = "";
                if (secretCode === ADMIN_CODE) role = "admin";
                else if (secretCode === CAPTAIN_CODE) role = "captain";
                else {
                    setError("Invalid Access Code.");
                    return;
                }
                
                await register(email, password, role);
                role === "admin" ? navigate('/admin') : navigate('/captain');
            } else {
                await login(email, password);
                navigate('/admin');
            }
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div style={{height: '100vh', display:'flex', alignItems:'center', justifyContent:'center', backgroundColor:'#0C0A1A'}}>
            <form onSubmit={handleSubmit} className="GlassCard" style={{width: 350, padding: 40, height: 'auto'}}>
                <h3 className="SectionTitle" style={{textAlign:'center', marginBottom: 20}}>
                    {isRegistering ? "Create Account" : "Login"}
                </h3>

                {error && <div style={{color: '#FF5C5C', marginBottom: 15, fontSize: 14, textAlign: 'center'}}>{error}</div>}

                <input 
                    className="DarkInput" 
                    placeholder="Email" 
                    type="email" 
                    value={email}
                    onChange={e => setEmail(e.target.value)} 
                    required
                />
                <input 
                    className="DarkInput" 
                    type="password" 
                    placeholder="Password" 
                    value={password}
                    onChange={e => setPassword(e.target.value)} 
                    required
                />

                {isRegistering && (
                    <input 
                        className="DarkInput" 
                        type="text" 
                        placeholder="Admin or Captain Code" 
                        value={secretCode}
                        onChange={e => setSecretCode(e.target.value)} 
                        required
                    />
                )}

                <button className="PrimaryButton" style={{width:'100%', marginTop: 10}}>
                    {isRegistering ? "Register" : "Log In"}
                </button>

                <div 
                    style={{marginTop: 20, textAlign: 'center', fontSize: 13, color: '#8F9EB5', cursor: 'pointer'}}
                    onClick={() => { setIsRegistering(!isRegistering); setError(""); }}
                >
                    {isRegistering ? "Have an account? Log In" : "Need an account? Register"}
                </div>
            </form>
        </div>
    );
};

export default Login;